import { ElButton, ElIcon, ElLink, ElRow, ElTag, randomCode } from '@qsxy/element-plus-react';
import './style.scss';
import { appName, INDEX_PATH, questionSamples } from '@/config';
import { useAppContext } from '@/AppContext';
import { useNavigate } from 'react-router-dom';
import { RootState } from '@/typings';
import { useDispatch, useSelector } from 'react-redux';
import { createKnowledge } from './api';
import { setUser } from '@/redux/reducer';

const Guide = (props: { callback: () => void }) => {
	const dispatch = useDispatch();
	const loginUser = useSelector<RootState, RootState['user']>(state => state.user ?? {});
	const navigate = useNavigate();
	const { conversationTitle, conversationType } = useAppContext();

	/** 新会话 */
	const handleChat = (title: string) => {
		conversationTitle.current = title.trim();
		conversationType.current = '3';
		navigate(`/chat/${randomCode(11)}`);
	};

	const pass = () => {
		if (loginUser?.isVisitor) {
			navigate(INDEX_PATH);
		} else {
			props?.callback?.();
			if (!loginUser.datasetId) {
				createKnowledge({ user: loginUser.username, name: loginUser.username, description: `${loginUser.username}的知识库` }).then(({ datasetId }) =>
					dispatch(setUser({ ...loginUser, datasetId })),
				);
			}
		}
	};

	return (
		<div className="ttn-guid">
			<div className="passby">
				<ElButton type="primary" link onClick={pass}>
					跳过引导
					<ElIcon name="angles-right" prefix="far" />
				</ElButton>
			</div>

			<div className="header">两步掌握{appName}个人知识库使用方法</div>
			<div className="content">
				<div className="row">
					<div className="subscript">1</div>
					<div className="text">
						<div className="text-base">
							上传文件或选择样例文件，支持多种格式文件，快速解析复杂内容，全面提升效率：
							<ul style={{ paddingLeft: 24, listStyle: 'disc' }}>
								<li>针对文件内容即时提问，快速获取答案，理清关键信息。</li>
								<li>自动识别报告、标准、案例及相关机构，一键连接国内外最新资料库。</li>
								<li>精准提取表格数据，轻松转换为可编辑格式，支持总结与问答功能。</li>
								<li>提取图片信息，提供智能总结与高效问答功能。</li>
							</ul>
						</div>

						<div
							className="sample-doc"
							onClick={() => {
								// eslint-disable-next-line @typescript-eslint/no-var-requires
								window.open(require('@/assets/sample.pdf'), '_blank');
							}}
						>
							<div className="file-name">
								<svg
									xmlns="http://www.w3.org/2000/svg"
									width="32"
									height="32"
									viewBox="0 0 24.75 24"
									fill="none"
									xmlnsXlink="http://www.w3.org/1999/xlink"
									strokeWidth="1"
									style={{ display: 'inline-block' }}
								>
									<g fill="none" transform="scale(.75)">
										<path fill="#fff" d="M4.5 5a4 4 0 014-4h13l7 7v19a4 4 0 01-4 4h-16a4 4 0 01-4-4z"></path>
										<path
											fill="#BCC2CC"
											fillRule="evenodd"
											d="m21.5 1 7 7v19a4 4 0 01-4 4h-16a4 4 0 01-4-4V5a4 4 0 014-4zm-1 1h-12a3 3 0 00-3 3v22a3 3 0 003 3h16a3 3 0 003-3V9h-5a2 2 0 01-2-2zm6.586 6L21.5 2.414V7a1 1 0 001 1z"
											clipRule="evenodd"
										></path>
										<rect width="26" height="13" x="3.5" y="13" fill="#D11A32" rx="1"></rect>
										<path
											fill="#fff"
											fillRule="evenodd"
											d="M8.5 16.5A.5.5 0 019 16h1a2.5 2.5 0 010 5h-.5v1.5a.5.5 0 01-1 0zm1 3.5h.5a1.5 1.5 0 000-3h-.5z"
											clipRule="evenodd"
										></path>
										<path fill="#fff" d="M20.5 16.5a.5.5 0 01.5-.5h3a.5.5 0 010 1h-2.5v2H24a.5.5 0 010 1h-2.5v2.5a.5.5 0 01-1 0z"></path>
										<path
											fill="#fff"
											fillRule="evenodd"
											d="M15 16a.5.5 0 00-.5.5v6a.5.5 0 00.5.5h1a2.5 2.5 0 002.5-2.5v-2A2.5 2.5 0 0016 16zm.5 6v-5h.5a1.5 1.5 0 011.5 1.5v2A1.5 1.5 0 0116 22z"
											clipRule="evenodd"
										></path>
									</g>
								</svg>
								<div className="file-title">
									<div className="font-semibold">【示例】数字碳中和联合实验室介绍</div>
									<div className="mt-1">2.92MB</div>
								</div>
							</div>
							<ElIcon className="ls-360-icon" name="arrow-up-right-from-square" prefix="far" />
						</div>
					</div>
				</div>

				<div className="row">
					<div className="subscript">2</div>
					<div className="text">
						<div className="text-base">
							在“全部”、“碳中和政策”或“绿色金融”模块中输入问题，快速获取精准答案。对感兴趣的参考文献或关键文件，轻松一键保存至个人知识库，系统自动提取文件中的核心数据，方便后续高效查阅与管理。
							<div className="ttn-question-sample">
								<div className="samples" style={{ marginTop: 0 }}>
									{/* @ts-ignore */}
									{questionSamples[1][3].map((item, index) => (
										<ElRow key={index}>
											<ElTag type="primary" disableTransitions>
												{item.kind}
											</ElTag>
											<ElLink underline onClick={() => handleChat(item.sample)}>
												{item.sample}
											</ElLink>
										</ElRow>
									))}
								</div>
							</div>
						</div>
					</div>
				</div>

				<ElButton type="primary" size="large" block onClick={pass}>
					知道了
				</ElButton>
			</div>
		</div>
	);
};

export default Guide;
